module.exports = __webpack_public_path__ + "res/MaterialIcons-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/MaterialIcons-Regular.ttf
// module id = 92
// module chunks = 1